import styled from 'styled-components'

import { getOptimizedImageUrl } from 'lib/image'

const bg = '/assets/images/background-emty.png'

export default function MyImage({
  src = '',
  alt = '',
  lazyload = true,
  imgixWidth,
  loading,
  ...props
}) {
  const imageUrl = getOptimizedImageUrl(src, imgixWidth)

  return (
    <ImageStyled
      src={imageUrl || bg}
      alt={alt}
      loading={loading || (lazyload ? 'lazy' : 'eager')}
      decoding="async"
      {...props}
    />
  )
}

const ImageStyled = styled.img`
  max-width: 100%;
  max-height: 100%;
`
